import React from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { useForm } from "react-hook-form";
import {
    Box, Grid,
    Button, IconButton,
    TextField, Select, MenuItem,
    FormHelperText, FormControl, FormControlLabel,
    RadioGroup, Radio, Checkbox,
    Dialog, DialogTitle, DialogContent,
    InputAdornment
} from '@material-ui/core';
import { useStyles } from "../../styles";
import * as Icons from "../../iconComponents";
import { useFormContext } from "react-hook-form";
import IndexedDb from '../../IndexedDb';

const Popup: React.FC<any> = ({ popState, setPopState, isNSWLocationIdb,setValue}): JSX.Element => {
    const classes = useStyles();
    // const { setValue} = fromBooking ? useForm() : useFormContext();
    //const pcrType = watch("pcr_type");
    const [scaleType, setScaleType] = React.useState<number>();
    const [Indexdb, setIndexdb] = React.useState("");
    React.useEffect(() => {
        let db: any = null;
        db = localStorage.getItem("PatientDB");
        setIndexdb(db);
        // if(isNSWLocationIdb) {
        //     setScaleType(2)
        // }
        // else {
        //     setScaleType(1)
        // }
    }, [])
    
    React.useEffect(() => {
        if(isNSWLocationIdb) {
            setScaleType(2)
        }
        else {
            setScaleType(1)
        }
    }, [isNSWLocationIdb])

    const handleAcuityChange = (value: any): void => {
        setValue("acuity", value);
        handleSituationindexdbsave("acuity", value)
        setPopState(!popState);
    }

    const handleSituationindexdbsave = async (Key: any, value: any): Promise<void> => {
        if (Indexdb != null || Indexdb != "") {
            const indexedDb = new IndexedDb(Indexdb);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            await indexedDb.deleteValue('Situation', Key);
            await indexedDb.putValue('Situation', { column: value !== undefined ? value : null, Patid: 0 }, Key);
        }
    }

    return (
        <>
            {popState && (<>
            <Dialog
                open={popState}
                onClose={() => setPopState(!popState)}
                className={classes.pcrDialog}
                fullScreen
            >
                <DialogTitle
                    disableTypography
                    style={{ backgroundColor: "#EFF0F2" }}
                >
                    CHOOSE ACUITY
                    <IconButton className={"closeButton"} onClick={() => setPopState(!popState)}>
                        <Icons.CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={{ padding: 0 }}>
                    <div className={(isNSWLocationIdb == null || isNSWLocationIdb == undefined) ? classes.acuitySelectionTab : classes.acuityTab}>
                        {(isNSWLocationIdb == null || isNSWLocationIdb == undefined) &&
                        <div
                            className={`tabItem ${(scaleType == 1) ? 'selected' : ''}`}
                            onClick={() => setScaleType(1)}
                        >
                            NON-NSW SCALE
                        </div>
                        }
                        {(isNSWLocationIdb == null || isNSWLocationIdb == undefined) &&
                        <div
                            className={`tabItem ${(scaleType == 2) ? 'selected' : ''}`}
                            onClick={() => setScaleType(2)}
                        >
                            NSW SCALE
                        </div>
                        }
                    </div>
                    <Grid container className={classes.acuitySelectionPopup}>
                        <Grid item xs={10} sm={8}>
                            {(scaleType == 1) ? (<>
                            <Grid container direction="column" spacing={5}>
                                <Grid item xs={12} sm={12}>
                                    <div className={"header high"} onClick={() => handleAcuityChange("5")}>
                                        High Acuity
                                        <span className={"icon"}>
                                            <Icons.AcuityIcon />
                                        </span>
                                    </div>
                                    <div className={"body"}>
                                        <div className={"text1"}>
                                            Patient requires active management or intervention and one or more of the following:
                                        </div>
                                        <div className={"text2"}>
                                            <ul>
                                                <li>Cardiorespiratory support</li>
                                                <li>Higher level of care than that required for a medium acuity patient</li>
                                                <li>IV infusion containing vasoactive agents</li>
                                                <li>Requiring PIPER or ARV transport</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <div className={"header medium"} onClick={() => handleAcuityChange("6")}>
                                        Medium Acuity
                                        <span className={"icon"}>
                                            <Icons.AcuityIcon />
                                        </span>
                                    </div>
                                    <div className={"body"}>
                                        <div className={"text1"}>
                                            Patient that is not high acuity and requires one or more of the following:
                                        </div>
                                        <div className={"text2"}>
                                            <ul>
                                                <li>Active management or intervention</li>
                                                <li>Specialised equipment monitoring</li>
                                                <li>IV infusion that does not contain vasoactive substances (other than GTN)</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <div className={"header low"} onClick={() => handleAcuityChange("7")}>
                                        Low Acuity
                                        <span className={"icon"}>
                                            <Icons.AcuityIcon />
                                        </span>
                                    </div>
                                    <div className={"body"}>
                                        <div className={"text1"}>
                                            Patient that is not high or medium acuity and has one or more of the following:
                                        </div>
                                        <div className={"text2"}>
                                            <ul>
                                                <li>Impaired cognitive function</li>
                                                <li>Diagnosis of chronic shortness of breath in which there has been no change</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                            </>) : (<>
                                <Grid container direction="column" spacing={5}>
                                <Grid item xs={12} sm={12}>
                                    <div className={"header classB"} onClick={() => handleAcuityChange("1")}>
                                        Class B
                                        <span className={"icon"}>
                                            <Icons.AcuityIcon />
                                        </span>
                                    </div>
                                    <div className={"body"}>
                                        <div className={"text1"}>
                                            Ongoing monitoring and/or active treatment or continuity of care
                                        </div>
                                        <div className={"text2"}>
                                            <ul>
                                                <li>Stable, involuntary, mental health patients</li>
                                                <li>Patient is expected to remain within 'Between the Flags' criteria</li>
                                                <li>Observation and monitoring of a stable cardiac monitored patient</li>
                                                <li>Condition is not life-threatening and not likely to become life-threatening during transport</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <div className={"header classC"} onClick={() => handleAcuityChange("2")}>
                                        Class C
                                        <span className={"icon"}>
                                            <Icons.AcuityIcon />
                                        </span>
                                    </div>
                                    <div className={"body"}>
                                        <div className={"text1"}>
                                            Supervision required with no active treatment
                                        </div>
                                        <div className={"text2"}>
                                            <ul>
                                                <li>Patient is expected to remain within 'Between the Flags' criteria</li>
                                                <li>May require equipment monitoring (except for cardiac)</li>
                                                <li>Observation and monitoring of an intravenous fusion</li>
                                                <li>Voluntary mental health patients or those on a CTO</li>
                                                <li>Condition is not life-threatening and not likely to become life-threatening during transport</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <div className={"header classD"} onClick={() => handleAcuityChange("3")}>
                                        Class D
                                        <span className={"icon"}>
                                            <Icons.AcuityIcon />
                                        </span>
                                    </div>
                                    <div className={"body"}>
                                        <div className={"text1"}>
                                            Supervision required with no active treatment
                                        </div>
                                        <div className={"text2"}>
                                            <ul>
                                                <li>Patient is expected to remain within 'Between the Flags' criteria</li>
                                                <li>Behaviourally stable</li>
                                                <li>Condition is not life-threatening and not likely to become life-threatening during transport</li>
                                                <li>Patient requiring oxygen therapy at 1-4LPM via nasal prongs</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <div className={"header classE"} onClick={() => handleAcuityChange("4")}>
                                        Class E
                                        <span className={"icon"}>
                                            <Icons.AcuityIcon />
                                        </span>
                                    </div>
                                    <div className={"body"}>
                                        <div className={"text1"}>
                                            Self-Caring - Low acuity requiring no or minimal supervision
                                        </div>
                                        <div className={"text2"}>
                                            <ul>
                                                <li>Outpatient and discharge transports not requiring stretcher</li>
                                                <li>Outpatient and discharge transport where pubic/private community transport or family and can be utilised</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                            </>)}
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
            </>)}
        </>
    );
}

export default React.memo(withRouter(Popup));